import React, { useEffect } from "react";
import Input from "./Input/Input";
import TextArea from "./TextArea/TextArea";
import SelectDd from "./SelectDd/SelectDd";
import DateTimePicker from "./DateTimePicker/DateTimePicker";
import CheckBox from "./CheckBox/CheckBox";
import SingleCheckBox from "./SingleCheckBox/SingleCheckBox";
import File from "./File/File";
import TimePicker from "./TimePicker/TimePicker";
import AutoComplete from "../FormikControl/AutoComplete/AutoComplete";
import SelectNew from "./SelectDd/SelectNew";
import DateAndTimePicker from "./DateAndTimePicker/DateAndTimePicker";
import ComboSelect from "./Combo/ComboSelect";

const FormikControl = (props) => {
  const { control, ...rest } = props;
  switch (control) {
    case "input":
      return <Input {...rest} />;
      break;
    case "textArea":
      return <TextArea {...rest} />;
      break;

    case "select":
      return <SelectDd {...rest} />;
      break;
    case "selectNew":
      return <SelectNew {...rest} />;
    case "radio":
      return null;
      break;

    case "checkbox":
      return <CheckBox {...rest} />;
      break;

    case "date":
      return <DateTimePicker {...rest} />;
      break;

    case "singlcheckbox":
      return <SingleCheckBox {...rest} />;
      break;

    case "file":
      return <File {...rest} />;
      break;

    case "timePicker":
      return <TimePicker {...rest} />;
      break;

    case "auto":
      return <AutoComplete {...rest} />;
      break;
      
    case "dateAndTime":
      return <DateAndTimePicker {...rest} />;
      break;
    case "combo":
      return <ComboSelect {...rest}/>
      break;
    default:
      return <h1>Invalid Values..!</h1>;
      break;
  }
};

export default FormikControl;
